import { AUTO_CALLER_ID } from '@/lib/callerIdAuto'

/**
 * The outgoing line picked in this browser tab (sessionStorage).
 *
 * A tab can outlive an account: session expired, then a login to another
 * company in the same tab. The remembered line was then sent as CustomCallerId
 * although it belonged to the previous company (Oct 2026: a Workless line sent
 * for company 230, the call left through the wrong provider and never rang).
 * So every read checks the line against the company's lines, and a line that
 * is not one of them is forgotten.
 */
export const SESSION_CALLER_ID_KEY = 'callizy_session_caller_id'

type Line = { phone_number?: string | null }

/**
 * The remembered line if it is one of `lines` (or Automatic). `lines` not
 * loaded yet: null, never an unchecked value.
 */
export function readSessionCallerId(lines: readonly Line[] | undefined | null): string | null {
  if (typeof window === 'undefined' || !lines) return null
  let stored: string | null = null
  try {
    stored = sessionStorage.getItem(SESSION_CALLER_ID_KEY)
  } catch {
    return null
  }
  if (!stored) return null
  if (stored === AUTO_CALLER_ID || lines.some((l) => l.phone_number === stored)) return stored
  clearSessionCallerId()
  return null
}

export function saveSessionCallerId(number: string): void {
  try {
    sessionStorage.setItem(SESSION_CALLER_ID_KEY, number)
  } catch {
    /* storage unavailable: the line is simply not remembered */
  }
}

export function clearSessionCallerId(): void {
  try {
    sessionStorage.removeItem(SESSION_CALLER_ID_KEY)
  } catch {
    /* ignored */
  }
}
